import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  DownloadFileRequest,
  DownloadFileResponse,
} from "../../models/FileDownload.model";

// const BASE_URL = "https://gateway.eb10.co.il/baribua/GetCompanyFile.ashx";
const BASE_URL =
  "https://gateway.eb10.co.il/baribua/GetCompanyFile.ashx?CompanyID=127&fileName=contracts/contract_70_136.pdf";

// 🔥 Thunk להורדת קובץ
export const downloadFile = createAsyncThunk<
  DownloadFileResponse,
  DownloadFileRequest,
  { rejectValue: string }
>(
  "fileDownload/downloadFile",
  async ({ companyId: _companyId, fileName }, { rejectWithValue }) => {
    try {
      // יצירת URL עם query parameters
      const url = new URL(BASE_URL);
      //   url.searchParams.append("CompanyID", companyId);
      //   url.searchParams.append("fileName", fileName);

      const response = await fetch(url.toString(), {
        method: "GET",
        headers: {
          Accept: "application/pdf, application/octet-stream, */*",
        },
      });

      if (!response.ok) {
        throw new Error(
          `שגיאה בהורדת הקובץ: ${response.status} ${response.statusText}`,
        );
      }

      // קבלת content-type
      const contentType =
        response.headers.get("content-type") || "application/octet-stream";

      // חילוץ שם הקובץ מה-URL או מה-headers
      let filename = fileName.split("/").pop() || "downloaded-file";

      // ניסיון לחלץ שם קובץ מ-Content-Disposition header
      const contentDisposition = response.headers.get("content-disposition");
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(
          /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/,
        );
        if (filenameMatch && filenameMatch[1]) {
          filename = filenameMatch[1].replace(/['"]/g, "");
        }
      }

      // המרת התגובה ל-blob
      const blob = await response.blob();

      return {
        blob,
        filename,
        contentType,
      };
    } catch (error) {
      console.error("❌ Download error:", error);
      const errorMessage =
        error instanceof Error ? error.message : "שגיאה לא ידועה בהורדת הקובץ";
      return rejectWithValue(errorMessage);
    }
  },
);

// 🔥 Thunk להורדה ושמירה אוטומטית
export const downloadAndSaveFile = createAsyncThunk<
  string,
  DownloadFileRequest,
  { rejectValue: string }
>(
  "fileDownload/downloadAndSaveFile",
  async (request, { dispatch, rejectWithValue }) => {
    try {
      // הורדת הקובץ
      const result = await dispatch(downloadFile(request)).unwrap();

      // יצירת URL זמני עבור הblob
      const blobUrl = URL.createObjectURL(result.blob);

      // יצירת link זמני והפעלת הורדה
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = result.filename;
      link.style.display = "none";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // ניקוי ה-URL הזמני
      URL.revokeObjectURL(blobUrl);

      return result.filename;
    } catch (error) {
      console.error("❌ Download and save error:", error);
      const errorMessage =
        error instanceof Error ? error.message : "שגיאה בהורדה ושמירת הקובץ";
      return rejectWithValue(errorMessage);
    }
  },
);

// 🔥 Thunk לפתיחת קובץ בטאב חדש
export const openFileInNewTab = createAsyncThunk<
  string,
  DownloadFileRequest,
  { rejectValue: string }
>(
  "fileDownload/openFileInNewTab",
  async (request, { dispatch, rejectWithValue }) => {
    try {
      // הורדת הקובץ
      const result = await dispatch(downloadFile(request)).unwrap();

      // יצירת URL זמני עבור הblob
      const blobUrl = URL.createObjectURL(result.blob);

      // פתיחה בטאב חדש
      const newWindow = window.open(blobUrl, "_blank");

      if (!newWindow) {
        throw new Error("לא ניתן לפתוח טאב חדש. יש לבדוק הגדרות חסימת pop-up");
      }

      // ניקוי ה-URL אחרי זמן קצר (לתת זמן לטאב להיטען)
      setTimeout(() => {
        URL.revokeObjectURL(blobUrl);
      }, 10000);

      return result.filename;
    } catch (error) {
      console.error("❌ Open file error:", error);
      const errorMessage =
        error instanceof Error ? error.message : "שגיאה בפתיחת הקובץ";
      return rejectWithValue(errorMessage);
    }
  },
);
